"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkDevice = checkDevice;
var _ReadinessCheck = require("@studio/constants/ReadinessCheck");
function checkDevice() {
  var isMobile = false;
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // List mobile user agents
  var mobileDevicesRegexes = [/android/i, /webos/i, /iphone/i, /ipad/i, /ipod/i, /blackberry/i, /windows phone/i];
  for (var _i = 0, _mobileDevicesRegexes = mobileDevicesRegexes; _i < _mobileDevicesRegexes.length; _i++) {
    var mobileDeviceRegex = _mobileDevicesRegexes[_i];
    if (userAgent.match(mobileDeviceRegex)) {
      isMobile = true;
    }
  }
  if (isMobile) {
    console.warn('ReadinessCheck - Unsupported device:', userAgent);
  }
  return {
    status: isMobile ? _ReadinessCheck.FAILED : _ReadinessCheck.PASSED
  };
}